import { setOpenModal } from "../../../store/interviewConfigReducer";
import SvgMapper from "./SvgMapper";
import { useDispatch } from "react-redux";
import { resetInterviewConfigField } from "../../../store/interviewConfigReducer";
import "./Style.css";

const Footer = ({ onCreateInterview, isSubmitting = false, isDisabled = false }) => {
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(setOpenModal(false));
    dispatch(resetInterviewConfigField());
  };

  return (
    <div className="footer-container">
      <button
        type="button"
        className="footer-button-cancel"
        onClick={() => closeModal()}
      >
        Cancel
      </button>
      <button
        type="button"
        disabled={isDisabled}
        className="footer-button-create"
        onClick={onCreateInterview}
      >
        {SvgMapper.createIcon("w-4 h-4")}
        <span>{isSubmitting ? "Creating..." : "Create Interview"}</span>
      </button>
    </div>
  );
};

export default Footer;
